import { useEffect, useState } from "react"
import { URL_BY_SITE } from "../utils/constants"

const CURRENT_SITE_NAME = "current-site"

export const useSiteLocation = (pathName = "") => {
  const siteByUrl = Object.keys(URL_BY_SITE).find(site =>
    pathName.includes(URL_BY_SITE[site])
  ) || ""
  const [siteLocation, setSiteLocation] = useState(siteByUrl)

  useEffect(() => {
    if (!siteLocation && localStorage.getItem(CURRENT_SITE_NAME)) {
      setSiteLocation(localStorage.getItem(CURRENT_SITE_NAME))
    }
    localStorage.setItem(CURRENT_SITE_NAME, siteLocation)
  }, [siteLocation])

  return siteLocation
}
